<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>FILTRI</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col md="2" sm="5" xs="12">
                                <v-select :items="arrYear" v-model="yearFrom" label="Anno" item-text="description"
                                    item-value="id">
                                </v-select>

                            </v-col>
                            <!--<v-col md="2" sm="5" xs="12">
                                <v-select :items="arrYear" v-model="yearTo" label="A" item-text="description"
                                    item-value="id">
                                </v-select>
                            </v-col>-->
                            <v-col md="4" sm="5" xs="12">
                                <div>
                                    <v-select v-model="selectedShop" :items="arrShops" :menu-props="{ maxHeight: '400' }"
                                        label="Negozi" multiple hint="Seleziona i negozi" item-text="description"
                                        item-value="id" persistent-hint>
                                    </v-select>
                                </div>
                            </v-col>
                            <v-col md="1" sm="5" xs="12">
                                <v-btn depressed color="primary" @click="getFatturati()">
                                    Filtra
                                </v-btn>
                            </v-col>

                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-tabs background-color="primary" dark>
                    <v-tab>
                        Negozi
                    </v-tab>
                    <v-tab>
                        Totali Selezionati
                    </v-tab>
                    <v-tab>
                        Totali
                    </v-tab>
                    <v-tab-item>
                        <v-row dense v-for="(value, shopId) in listaIncassi" :key="shopId">
                            <v-col>
                                <v-expansion-panels v-model="panels[shopId]">
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <b>{{ getShopDescription(shopId) }}</b>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-data-table :item-class="rowClass" :hide-default-footer="true"
                                                :headers="headers" :items="value" :items-per-page="15" item-key="id"
                                                class="elevation-1" calculate-widths>
                                                <template v-slot:item.diff="{ item }">
                                                    <span v-if="item.diff > 0" style="color:green">
                                                        <b>{{ item.diff }}</b>
                                                    </span>
                                                    <span v-else style="color:red">
                                                        <b>{{ item.diff }}</b>
                                                    </span> %
                                                </template>
                                            </v-data-table>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item>
                        <TotaleFatturati ref="totali-selezionati" :year-from="yearFrom" :year-to="yearTo" :shop-ids="selectedShop"></TotaleFatturati>
                    </v-tab-item>
                    <v-tab-item>
                        <TotaleFatturati :year-from="yearFrom" :year-to="yearTo"></TotaleFatturati>
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>

    </v-container>
</template>
<style scoped lang="scss">
.v-data-table::v-deep {

    .background-blue {
        background-color: aqua;
    }

    .background-green {
        background-color: greenyellow;
    }

    .v-data-table-header {
        background-color: #dddddd;

    }

    .total-class {
        background-color: #ddd;
        font-weight: bold;
    }

    .column-text-bold {
        font-weight: bold;
    }

}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    color: black;
}
</style>
<script>
import requests from "../../requests";
import TotaleFatturati from '../../components/TotaleFatturati.vue';
export default {
    name: "kpi-page",

    components: {
        TotaleFatturati
    },

    data: () => {
        return {
            headers: [],
            menu: false,
            yearFrom: 0,
            yearTo: 0,
            arrYear: [],
            listaIncassi: {},
            panels: {},
            arrShops: [],
            selectedShop: [],
            editIncasso: {},
            totali: {}
        };
    },
    mounted() {
        console.log("Incassi List Mounted.");

        this.yearFrom = parseInt(this.$moment().format('YYYY'));
        this.yearTo = parseInt(this.$moment().subtract(1, 'years').format('YYYY'));

        for (let i = this.yearFrom; i >= (this.yearFrom - 10); i--) {
            this.arrYear.push({
                id: i,
                description: i
            });
        }
        this.getShopList();
    },
    methods: {

        getShopList() {
            requests.getShopList().then(res => {
                this.arrShops = res.data;
            })
        },

        async getFatturati() {
            let tmp = {};
            let tmpPanel = {};

            this.yearTo = parseInt(this.$moment(this.yearFrom, "YYYY").subtract(1, 'years').format('YYYY'))

            for (let i = 0; i < this.selectedShop.length; i++) {
                let shopId = this.selectedShop[i];
                const res = await requests.getIncassiPerAnno(this.yearFrom, this.yearTo, shopId);
                tmp[shopId] = res.data;
                tmpPanel[shopId] = 0;
            }
            this.createHeadear();
            this.listaIncassi = tmp;
            this.panels = tmpPanel;


            this.$refs['totali-selezionati'].getTotali();
        },

        getShopById(id) {
            return _.find(this.arrShops, { id: id });
        },

        rowClass(item) {
            if (item.mese == 'TOTALE') {
                return 'total-class';
            }
            return '';
        },

        createHeadear() {
            this.headers = [];
            this.headers.push(
                { text: "Mese", value: "mese", divider: true, sortable: false },
            );

            for (let i = this.yearFrom; i >= this.yearTo; i--) {
                this.headers.push({
                    text: i, value: "anno_" + i, divider: true, sortable: false, cellClass: 'column-text-bold'
                });
            }

            this.headers.push(
                { text: "Diff % sul " + this.yearTo, value: "diff", divider: true, sortable: false },
            )
        },

        getShopDescription(id) {
            let shop = _.find(this.arrShops, { id: parseInt(id) });
            if (shop)
                return shop.description
            return '';
        },

        calcoloTotali(datiTotali) {
            this.totali = {};
            let arrField = [
                'incasso', 'conta_persone', 'fatturato_mq', 'media_scontrino',
                'num_scontrini', 'scontrini_ingressi'
            ];

            _.forEach(arrField, (field) => {
                _.forEach(datiTotali, (value) => {
                    if (_.isUndefined(this.totali[field])) {
                        this.$set(this.totali, field, 0);
                    }
                    this.totali[field] += value[field]
                });
            });

            this.totali['media_scontrino'] = this.totali.incasso / this.totali.num_scontrini;
            var num = Math.round((this.totali.conta_persone / this.listaIncassi.length + Number.EPSILON) * 100) / 100
            this.totali['media_scontrino_anno'] = num;
        }
    },

    filters: {
        formatEuro(number) {
            if (_.isNaN(number)) return 0;
            return new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
            }).format(number);
        },
    }
};
</script>
